import * as styles from './CommonError.css';
import { ErrorGraphicIcon } from '@/assets/icons';

type PropTypes = {
  title?: string;
  message?: string;
  showIcon?: boolean;
};

const CommonError = ({
  title = '이용에 불편을 드려 죄송해요!',
  message = `페이지를 표시할 수 없어요\n문제가 지속되면 고객센터로 문의해 주세요`,
  showIcon = true,
}: PropTypes) => {
  return (
    <div className={styles.container}>
      {showIcon && <ErrorGraphicIcon width={210} />}
      <div className={styles.contents}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
};

export default CommonError;
